<template>
  <kendo-dropdownlist
    ref="cmpyCdRef"
    :data-source="cmpyCdDataArray"
    :data-text-field="'cmpyNm'"
    :data-value-field="'cmpyCd'"
    :index="0"
    :style="'width: 100%;'"
    @change="onChangeCmpyCdDropdownList"
  >
  </kendo-dropdownlist>
</template>

<script>
  import ApiUtil from '@/api/api.util'
  import ApiConfig from '@/api/api.config'

  import Vue from 'vue'
  Vue.prototype.EventBus = new Vue()

  export default {
    name: 'CompanyDropdown',
    props  : [ 'customCompanyArr' ],
    created: function() {
      let vm = this

      let companyListParam = {
        loginUserToken : sessionStorage.lutk
      }

      ApiUtil.post(`${ApiConfig.platformDomain}/v1/ebmp/admin/user/companyList.json`, companyListParam)
      .then(function (response) {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }

        const resultStatus = response.data.resultStatus

        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }

        vm.cmpyCdDataArray = response.data.resultData

        if(vm.$props.customCompanyArr !== undefined && vm.$props.customCompanyArr !== null) {
          vm.$props.customCompanyArr.forEach(custom => {
            vm.cmpyCdDataArray.splice(0, 0, custom)
          })
        }
      })

    },
    methods: {
      onChangeCmpyCdDropdownList: function(e) {

        const vm = this
        let data = {
          cmpyCd: vm.$refs.cmpyCdRef.kendoWidget().value(),
          cmpyNm: vm.$refs.cmpyCdRef.kendoWidget().text()
        }
        vm.EventBus.$emit('onChangeDropdownCompanyComponent', data)

        // type2
        /*if(this.$parent.callbackOnChangeDropdownCompany !== undefined) {
          this.$parent.callbackOnChangeDropdownCompany(e)
        }*/
      }
    },
    data: function() {
      return {
        cmpyCdDataArray: []
      }
    }
  }
</script>

<style scoped>

</style>
